import { BRANDS, DEFAULT_BRAND_ID } from "./brands";

export function resolveBrandFromHostname(hostname) {
    const match = Object.values(BRANDS).find(brand =>
        brand.hostnames.some(domain =>
            hostname === domain || hostname.endsWith(`.${domain}`),
        ),
    );

    return match || BRANDS[DEFAULT_BRAND_ID];
}
